// Frontend inbox tunables; max_attachment_bytes mirrors backend ATTACHMENT_TOTAL_BYTES_CAP.
export const INBOX_CONFIG = {
    default_per_page:      25,
    default_order_by:      "last_message_at",
    activity_page_size:    50,
    msg_preview_max:       140,
    snippet_preview_default: 80,
    snippet_preview_long:   200,
    recent_replies_limit:    5,
    search_debounce_ms:    300,
    snooze_past_grace_ms:  60 * 1000,
    drag_leave_debounce_ms: 80,
    max_attachment_bytes:  24 * 1024 * 1024,
    // message-body iframe sizing.
    message_body_initial_height_px: 40,
    // Safety backstop against a runaway measurement — NOT a layout limit. Messages
    // render at full natural height (iframe is scrolling="no") so the conversation
    // pane is the only scroller; a low cap here would clip long replies / quoted
    // history and force a nested scrollbar inside the message.
    message_body_max_height_px:   20000,
    message_body_height_buffer_px:   8,
    message_body_measure_floor_px:  24,
    message_body_descendant_scan_max: 2000,
    message_body_remeasure_delays_ms: [100, 300, 600, 1200, 2000, 3000],
    // Must match backend INBOX_CONFIG_DEFAULTS.user_intent_max_chars.
    user_intent_max_chars: 600,
};

// Must match backend AI_SUGGEST_MODE.
export const SUGGEST_MODE = {
    AUTO:      "auto",
    REPLY:     "reply",
    FOLLOW_UP: "follow_up",
};

// Must match backend CHANNEL_TYPE.
export const CHANNEL_SLUG = {
    EMAIL:    "email",
    LINKEDIN: "linkedin",
    WHATSAPP: "whatsapp",
    TWILIO:   "twilio",
};

// Whitelisted by INBOX_TARGET_ACTION in routes/inbox/inbox.js.
// Floor for refresh-loading visibility so cached responses don't flash too briefly.
export const INBOX_REFRESH_MIN_VISIBLE_MS = 300;

export const TARGET_ACTION = {
    INTERESTED:     "interested",
    MEETING_BOOKED: "meeting_booked",
    NOT_INTERESTED: "not_interested",
};

// Every command the Actions popover can dispatch — superset of TARGET_ACTION.
export const THREAD_ACTION = {
    ...TARGET_ACTION,
    ARCHIVE:        "archive",
    STOP_SEQUENCE:  "stop_sequence",
};

export const STATUS_FILTER = {
    ALL:      "all",
    UNREAD:   "unread",
    REPLIED:  "replied",
    SNOOZED:  "snoozed",
    DONE:     "done",
};

export const PROSPECT_TAB = {
    ACTIVITY: "activity",
    PROFILE:  "profile",
};

// Matches backend CHANNEL_MESSAGE_THREAD_DIRECTION (message/thread last_direction).
export const MESSAGE_DIRECTION = {
    INBOUND:  "inbound",
    OUTBOUND: "outbound",
};

// Matches backend classifyInboundEmailHandler output.
export const CLASSIFICATION_KIND = {
    BOUNCE:     "bounce",
    AUTO_REPLY: "auto_reply",
};
